import BaseModel from 'volta/models/base-model';
import { normalize } from 'volta/utils/api/serialize-and-push';

import { attr, belongsTo } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import { Type } from '@warp-drive/core-types/symbols';

import type { IResourceName } from './base-model';
import type UserProfile from 'volta/models/user-profile';
import type Task from 'volta/models/task';

export const ResourceName: IResourceName = {
  singular: 'activity',
  plural: 'activities'
};

export default class Activity extends BaseModel {
  @attr('string') declare command: string;
  @attr() payload: any;
  @attr('array') entityIds!: string[];
  @attr('boolean', { defaultValue: true }) isMultiple!: boolean;
  @attr('string') entityType?: string;
  @attr('boolean', { defaultValue: false }) entityIsNew?: boolean;

  @belongsTo('user-profile', { async: false, inverse: null }) createdBy!: UserProfile;

  get userId() {
    return this.createdBy.userId;
  }

  get userName() {
    return this.createdBy.login;
  }

  get entityId() {
    return this.isMultiple ? undefined : this.entityIds[0];
  }

  @cached
  get commentPayload() {
    if (['CreateTask'].includes(this.command) && (this.payload as Task).taskType === 'COMMENT') {
      const existing = this.store.peekRecord<Task>('task', this.payload.id);
      if (existing && existing.updatedAt >= this.payload.updatedAt) {
        return existing;
      } else {
        const newTask = normalize('task', this.payload) as Task;
        newTask.createdBy = this.createdBy;
        return newTask;
      }
    }
    return undefined;
  }

  [Type] = 'activity' as const;
}
